<template>
  <Input
    type="textarea"
    :rows="4"
    v-model="item.value.multipleLineTextAttribute.answer"
    :placeholder="fillBlankPlaceholder + minWordQuantity + maxWordQuantity "
    @on-change="multipletextMessage(item, item.value.multipleLineTextAttribute.answer)"
  />
</template>

<script>
// class="input_bgc"
export default {
  props: ['item'],
  data() {
    return {
      fillBlankPlaceholder: '请输入',
      minWordQuantity: '',
      maxWordQuantity: '',
      windowHeight: document.body.scrollHeight,
    }
  },
  created: function () {
    this.minWordQuantity = this.item.value.multipleLineTextAttribute
      .minWordQuantity
      ? '(最少填' +
        this.item.value.multipleLineTextAttribute.minWordQuantity +
        '个字)'
      : ''
    this.maxWordQuantity = this.item.value.multipleLineTextAttribute
      .maxWordQuantity
      ? '(最多填' +
        this.item.value.multipleLineTextAttribute.maxWordQuantity +
        '个字)'
      : ''
    this.fillBlankPlaceholder = this.item.value.multipleLineTextAttribute
      .defaultValue
      ? this.item.value.multipleLineTextAttribute.defaultValue
      : ''
  },
  methods: {
    // 多行文本验证  this.item.value.multipleLineTextAttribute.errorMessage != "" ||
    multipletextMessage: function (data, val) {
      data.value.multipleLineTextAttribute.verifyStatus = true
      // console.log(val)
      if (
        val.length <
          Number(data.value.multipleLineTextAttribute.minWordQuantity) &&
        data.value.multipleLineTextAttribute.minWordQuantity
      ) {
        this.$Message.warning(
          data.value.multipleLineTextAttribute.errorMessage != ''
            ? data.value.multipleLineTextAttribute.errorMessage
            : '最少填' +
                data.value.multipleLineTextAttribute.minWordQuantity +
                '字'
        )
        data.value.multipleLineTextAttribute.verifyStatus = false
        //  data.value.multipleLineTextAttribute.answer=""
      } else if (
        val.length >
          Number(data.value.multipleLineTextAttribute.maxWordQuantity) &&
        data.value.multipleLineTextAttribute.maxWordQuantity
      ) {
        this.$Message.warning(
          data.value.multipleLineTextAttribute.errorMessage != ''
            ? data.value.multipleLineTextAttribute.errorMessage
            : '最多填' +
                data.value.multipleLineTextAttribute.maxWordQuantity +
                '字'
        )
        data.value.multipleLineTextAttribute.verifyStatus = false
      }
    },
  },
}
</script>
<style lang="less">
.ivu-input-wrapper {
  background-color: rgba(255, 255, 255, 0.6);
}
</style>


